import React, {PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import {Dropdown} from 'semantic-ui-react';
import CommentModal from './commentModal';
import RemoveRankModal from './removeRankModal';
import EditCategoryFundingModal from './editCategoryFundingModal';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {some} from 'lodash';

export class ActionSubApplicationModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      actionType: '',
      bulkActionType: '',
    };
  }

  handleActionChange = (value) => {
    this.setState({
      actionType: value,
    });
  };

  handleBulkActionChange = (e) => {
    const {value} = e.target;
    this.setState({
      bulkActionType: value,
    });
  };

  resetActions = () => {
    this.setState({
      bulkActionType: '',
      actionType: '',
    });
  };

  showModal = (bulk) => {
    const {actionType, bulkActionType} = this.state;
    const {
      comments = '',
      results,
      entityId,
      fedShareAmount,
      categoryOptions,
      handleSave,
      categoryLabel,
      handleCardDelete,
      subApplicationId,
    } = this.props;
    const action = bulk ? bulkActionType : actionType;
    switch (action) {
      case 'comment':
        return <CommentModal {...{comments}} resetActions={this.resetActions} />;
      case 'removeSubApp':
        return (
          <RemoveRankModal
            entityId={entityId}
            fedShareAmount={fedShareAmount}
            results={results}
            handleCardDelete={handleCardDelete}
            resetActions={this.resetActions}
          />
        );
      case 'editCategory':
        return (
          <EditCategoryFundingModal
            {...{
              results,
              categoryOptions,
              categoryLabel,
              handleSave,
              entityId,
            }}
            resetActions={this.resetActions}
          />
        );
      case 'subApplicationView':
        window.open(`/subApplication/${subApplicationId}/view`, '_blank');
        this.resetActions();
      default:
        return;
    }
  };

  render() {
    const {entityId, bulk, masterChecked, results, options} = this.props;
    const {bulkActionType, actionType} = this.state;
    const enableSelect =
      masterChecked === true || some(results, 'checked') ? false : true;

    return (
      <>
        {this.showModal(bulk)}
        {bulk ? (
          <InlineSelect
            search
            selection
            title="Select an action"
            name="selectedAction"
            id="selectActionsBulk"
            options={options}
            handleChange={this.handleBulkActionChange}
            value={bulkActionType}
            disabled={enableSelect}
            role="menu"
          />
        ) : (
          <Dropdown
            selectOnNavigation={false}
            selectOnBlur={false}
            text={'Actions'}
            options={options}
            onChange={(e, {value}) => this.handleActionChange(value)}
            value={actionType}
          />
        )}
      </>
    );
  }
}

export default ActionSubApplicationModal;
